const Spinner = () => (
  <div className="spinner-container">
    <div className="loader"></div>
  </div>
);

export default Spinner;
